/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  GET_PRODUCTS,
  GET_CATEGORY_PRODUCTS,
  CREATE_PRODUCT,
  UPDATE_PRODUCT,
  GET_PRODUCT,
  SET_ALLOWED_PRODUCTS,
  TOGGLE_CUSTOM_MODAL,
  SHOW_PRODUCT_TO_FRONT,
} from 'src/redux/actions/productActions';

const initialState = {
  products: null,
  categoryProducts: null,
  product: null,
  allowedProducts: JSON.parse(localStorage.getItem('allowedProducts')) ?? [],
  allowedProduct: null,
  isCustomModalVisible: false,
  purchaseService: { price: 0, currency: 'SGD' },
};

const productReducer = (state = initialState, action) => {
  switch (action.type) { 

    case GET_PRODUCTS: {
      const products = action.payload
      return produce(state, (draft) => {
        draft.products = products
        draft.product = null
      })
    }

    case GET_CATEGORY_PRODUCTS: {
      const products = action.payload
      return produce(state, (draft) => {
        draft.categoryProducts = products
      })
    }

    case GET_PRODUCT: {
      const product = action.payload;

      return produce(state, (draft) => {
        draft.product = product;
      });
    }

    case CREATE_PRODUCT: {
      const product = action.payload;

      return produce(state, (draft) => {
        draft.product = product;
      });
    }

    case UPDATE_PRODUCT: {
        const product = action.payload;
        return produce(state, (draft) => {
          draft.product = product;
        });
    }

    case SET_ALLOWED_PRODUCTS: {
      return produce(state, (draft) => {
        draft.allowedProducts = action.payload;
        draft.allowedProduct = null;
      });
    }

    case SHOW_PRODUCT_TO_FRONT: {
      return produce(state, (draft) => {
        draft.allowedProduct = action.payload;
      });
    }

    case TOGGLE_CUSTOM_MODAL: {
      return produce(state, (draft) => {
        draft.isCustomModalVisible = action.payload.visibility;
        draft.purchaseService = action.payload.service;
      });
    }

    default: {
      return state;
    }
  }
};

export default productReducer;
